import { ModelDataService } from './../../base-services/model-data.service';
import { UserService } from './../../base-services/user.service';
import { BaseContainerService } from './services/base-container-service';
import { BaseEntity } from './../../base-models/base-entity';
import { ActivatedRoute } from '@angular/router';
import { ModalContainerService } from './services/modal-container.service';
import { BaseContainer } from './base-container';
import { ModalService } from '../../base-services/modal.service';
import { ViewChild, Optional, Inject } from '@angular/core';
import { DefaultListModalComponent } from '../../base-components/default-list/default-list-modal.component';
export class BaseModalContainer<T extends BaseEntity> extends BaseContainer<T> {
    constructor(
        protected modalContainerService: ModalContainerService<T>,
        protected activatedRoute: ActivatedRoute,
        protected modalService: ModalService,
        protected userService: UserService,
        @Optional() @Inject(ModelDataService) protected modelDataService?: ModelDataService
    ){
           super(modalContainerService, activatedRoute, userService, modelDataService);
    }    

    //AddItem(){
        //this.modalService.ShowModal(-1, this.modelData)
            //.result
                //.then((result) => {
                    //this.containerService.EmitItem(result);
                //})
    //}

    @ViewChild('defaultList', /* TODO: add static flag */ {static: true}) defaultList: DefaultListModalComponent<T>;

    //ngAfterViewInit(){
        //this.defaultList.routeName = this.routeName;
    //}
}
